import { LOCALES } from "../../i18n";
import { useI18n } from "../../contexts/I18nContext";

export default function LanguageSelector() {
  const { locale, setLocale, t } = useI18n();

  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "12px",
        color: "#555",
      }}
    >
      <span>{t("Sprache")}</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        style={{
          border: "1px solid #d0d0d0",
          borderRadius: "6px",
          padding: "4px 8px",
          fontSize: "12px",
          background: "#fff",
          color: "#333",
        }}
      >
        <option value={LOCALES.DE}>{t("Deutsch")}</option>
        <option value={LOCALES.EN}>{t("Englisch")}</option>
      </select>
    </label>
  );
}
